
import { useEffect } from "react";
import {FundAddPaymentForm} from "../../../types/formTypes"
import {FormField} from "../../../types/types"
import { useMutationByMethod } from "../../../services/hooks/useMutationByMethod";
import { PostUrl } from "../../../api/endpointConfig";
import { useParams } from "react-router-dom";
import { useLoader } from "../../../Loader/LoaderContext";
import { ToastService } from "../../../utils/toastService";
import { useFundContext } from "../../../Context/FundManagementContext";
import { useNavigate } from 'react-router-dom';



const useAddPayment = () => {
  const { id } = useParams();
  const { showLoader, hideLoader } = useLoader();
  const { fundDetail } = useFundContext()
  const nagivate = useNavigate();
  const today = new Date();
  // Feature date disabling in date picker
  const minDatePrev = new Date(
  today.getFullYear() - 100,
  today.getMonth(),
  today.getDate()
)
  .toISOString()
  .split("T")[0];

  // Maximum date: today (no future date allowed)
  const maxDatePrev = today.toISOString().split("T")[0];

  const minDate = new Date(today);
  minDate.setDate(today.getDate() + 1);
  const formattedMinDate = minDate.toISOString().split("T")[0]; // YYYY-MM-DD

  // Set maxDate as 10 years from today
  const maxDate = new Date(
    today.getFullYear() + 10,
    today.getMonth(),
    today.getDate()
  ).toISOString().split("T")[0];

  const {mutate} = useMutationByMethod<any>(
    "post",
    `${PostUrl.postFund}/${Number(id)}`
  );
  const fundsFormFields: FormField<FundAddPaymentForm>[] = [
  { name: 'fund_disburstment_amt', text_label: 'Funds Disbursed', type: 'number',validate:(val: any) => val.length == 0 && "fund disburstment amt is required " ,  grid: { xs: 12, sm: 6, md: 3, lg: 2 }},
  { name: 'payment_date', text_label: 'Payment Date', type: 'date',inputProps:{
    min: minDatePrev,
    // max: maxDatePrev,
  }, validate:(val: any) => val?.length == 0 && "Payment date is required ",  grid: { xs: 12, sm: 6, md: 3, lg: 3 } },
  { name: 'transaction_number',options:[{"label":"Cheque Details", "value" :"cheque_details"},{"label":"DD Details", "value" :"DD_number"}, {"label":"Transaction ID", "value" :"transaction_ref_no"}], text_label: 'DD Details/Transaction ID/Cheque Details',validate: (val: any) => val.length == 0 && "Please select any one Option", type: 'textWithDropDown', grid: { xs: 12, sm: 6, md: 4, lg: 4 } },
  { name: 'new_purpose', text_label: 'Purpose',options:fundDetail?.new_purpose,  type: 'select',validate:(val: any) => val.length == 0 && "purpose is required ",  grid: { xs: 12, sm: 4, md: 3, lg: 3} },
  { name: 'installment_paid', text_label: 'Installment Given', validate: (val: any) =>
        val?.length == 0 && "Installment paid no is required ", type: 'number', grid: { xs: 12, sm: 3, md: 4, lg: 4 } },
  { name: 'next_installment_dt', text_label: 'Next Installment Date',inputProps:{
    min: minDatePrev,
    // max: maxDate,
  },validate:(val: any) => val?.length == 0 && "Next installment date is required ", type: 'date', grid: { xs: 12, sm: 6, md: 4, lg: 4 } },
  { name: 'next_installment_purpose', text_label: 'Next Installment Purpose', options:fundDetail?.purpose,validate:(val: any) => val.length == 0 && "Next installment purpose is required ", type: 'select', grid: { xs: 12, sm: 6, md: 4, lg: 4 } },
  { name: 'next_installment_amt', text_label: 'Next Installment Amount',validate:(val: any) => val.length == 0 && "Next installment Amount is required ", type: 'number',grid: { xs: 12, sm: 6, md: 4, lg: 4 } },
  { name: 'description', text_label: 'Description', type: 'textArea', grid: { xs: 12, sm: 12, md: 12, lg: 12 }},
];
const buildPayload = (data:any) => {
  const { new_purpose, ...rest } = data;

  const selectedPurpose = fundDetail?.new_purpose?.find(
    (item: any) => item.allocation_id === new_purpose
  );

  return {
    ...rest,
    purpose: selectedPurpose?.purpose,
      allocation_id: selectedPurpose?.allocation_id
  };
};

  const handleOnSubmit = (formData: FundAddPaymentForm) => {
    const payload = buildPayload(formData);
  
    showLoader()
    mutate(payload, {
          onSuccess: (data:any) => {
            hideLoader()
            ToastService.success('The scholarship has been granted successfully.');
            nagivate(`/fund-viewpayment/${Number(id)}`);
          },
          onError: (err:any) => {
            hideLoader()
            console.error("error", err);
            ToastService.error(err)
          },
        })
  }
  return { fundsFormFields,handleOnSubmit, fundDetail }
}

export default useAddPayment